import { Chip } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { CUSTOMER_PURCHASE_ORDER_STATUS_TO_LABEL } from "../../constants"

import { CustomerPurchaseOrderStatus } from "@/graphql/codegen/graphql"

const CUSTOMER_PURCHASE_ORDER_STATUS_TO_CLASS_NAME: Partial<Record<CustomerPurchaseOrderStatus, string>> = {
  [CustomerPurchaseOrderStatus.Open]: "border-primary-300",
  [CustomerPurchaseOrderStatus.PartiallyShipped]: "border-tertiary-orange-500",
  [CustomerPurchaseOrderStatus.Complete]: "border-tertiary-green-500",
}

interface CustomerPurchaseOrderStatusChipProps {
  status: CustomerPurchaseOrderStatus
}

export const CustomerPurchaseOrderStatusChip: FC<CustomerPurchaseOrderStatusChipProps> = ({ status }) => (
  <Chip
    size='small'
    variant='outlined'
    label={CUSTOMER_PURCHASE_ORDER_STATUS_TO_LABEL[status]}
    className={twMerge("bg-transparent text-xs text-gray-800", CUSTOMER_PURCHASE_ORDER_STATUS_TO_CLASS_NAME[status])}
  />
)
